import { useState, useEffect } from 'react';
import perfil from '../../../assets/image/Home/perfil.png';
import { Bell, Mail, User } from "lucide-react";
import AlunosPresentesChart from '../../Relatorios/Frequencia-Alunos/FrequenciaAlunos';
import AulasCalendar from '../../CalendarioAulas/CalendarioAulas';
import { authAPI } from '../../../api/authApi';
import './SidebarProfile.css';

const IconChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m9 18 6-6-6-6"></path>
  </svg>
);

const IconMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="12" x2="20" y2="12"></line>
    <line x1="4" y1="6" x2="20" y2="6"></line>
    <line x1="4" y1="18" x2="20" y2="18"></line>
  </svg>
);

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregarDadosUsuario = async () => {
      try {
        const response = await authAPI.getProfile();
        setUsuario(response.data);
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error);
      } finally {
        setLoading(false);
      }
    };

    carregarDadosUsuario();
  }, []);

  const toggleSidebar = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIsOpen(!isOpen);
    setTimeout(() => setIsAnimating(false), 400);
  };

  const getProgressColorClass = (progress) => {
    if (progress < 75) return 'progress-low';
    if (progress < 80) return 'progress-medium';
    return 'progress-high';
  };

  const getSaudacao = () => {
    const hora = new Date().getHours();
    if (hora < 12) return 'Bom dia';
    if (hora < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  if (loading) {
    return (
      <div className="app-container">
        <div className={`sidebar-profile ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
          <div className="sidebar-header-profile">
            {isOpen && <h1 className="sidebar-title">Seu perfil</h1>}
            <button onClick={toggleSidebar} className={`toggle-button ${isOpen ? 'right-aligned' : 'center-aligned'}`}>
              {isOpen ? <IconChevronRight /> : <IconMenu />}
            </button>
          </div>
          <div className="profile-content">
            <p>Carregando dados...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div 
        className={`sidebar-profile ${isOpen ? 'sidebar-open' : 'sidebar-closed'} ${isOpen ? 'sidebar-open-profile' : 'sidebar-close-profile'}`}
      >
        <div className="sidebar-header-profile">
          {isOpen && <h1 className="sidebar-title">Seu perfil</h1>}
          <button 
            onClick={toggleSidebar} 
            className={`toggle-button ${isOpen ? 'right-aligned' : 'center-aligned'}`}
            disabled={isAnimating}
          >
            {isOpen ? <IconChevronRight /> : <IconMenu />}
          </button>
        </div>

        <div className={`profile-content ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
          {isOpen && (
            <>
              <div className="profile-container">
                <div className="progress-circle-container">
                  <div
                    className={`progress-circle ${getProgressColorClass(80)}`}
                    style={{ '--progress': '80%' }}
                  >
                    <img
                      src={perfil}
                      alt="Foto de perfil"
                      className="profile-photo"
                    />
                  </div>
                </div>
                <h2 className="profile-name">
                  {getSaudacao()} {usuario?.nome || 'Professor'}!
                </h2>
                <p className="profile-subtitle">Você está com uma <span className='profile-status'>ótima</span> <br /> frequência!</p>
                <div className="icons-container">
                  <button className="circle-icon-button" aria-label="Notificações">
                    <Bell className="icon-profile-sidebar" />
                    <span className="notification-badge"></span>
                  </button>
                  <button className="circle-icon-button" aria-label="Caixa de e-mail">
                    <Mail className="icon-profile-sidebar" />
                    <span className="notification-badge"></span>
                  </button>
                  <button className="circle-icon-button" aria-label="Perfil">
                    <User className="icon-profile-sidebar" />
                  </button>
                </div>
                <div className='chart-frequencia-aluno'>
                  <AlunosPresentesChart />
                </div>
                <div className='calender-aulas-container'>
                  <AulasCalendar />
                </div>
              </div>

              <div className="sidebar-footer">
                <button className="sidebar-footer-button">Abrir chamado</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}